module.exports = __webpack_public_path__ + "static/2-cate-f553eb2c9783bc0004835d3a08a93973.jpg";